import { ratingDimensions } from "@/mocks/fengchiData";

export default function RatingBreakdown() {
  return (
    <section id="dimensions" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-[0.85fr_1.15fr] gap-8 lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-2 text-accent-600 text-sm font-medium">
              <i className="ri-equalizer-line" />
              评分怎么来的
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              不只看一个总分，拆开看六个维度
            </h2>
            <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
              一部作品好不好看，往往不是一个数字能说清的。我们把风驰影院作品的口碑拆成六个维度，
              分别整理观众印象，让你能按自己在意的点来判断——有人重视剧情，有人更在意画面和氛围，
              这里都能对得上。
            </p>

            <div className="mt-6 rounded-lg border border-secondary-200 bg-secondary-50 p-5">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-lightbulb-flash-line text-xl" />
              </span>
              <p className="mt-3 text-sm text-foreground-800 leading-relaxed">
                小提示：如果你的判断标准是「画面与氛围」，可以优先看摄影与配乐两项；
                如果你更在意「看得下去」，那么节奏与剧本两项更值得参考。
              </p>
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-8">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                六维口碑均分
              </h3>
              <span className="text-xs text-foreground-500">满分 10 分</span>
            </div>

            <div className="mt-6 space-y-5">
              {ratingDimensions.map((dim, index) => (
                <div key={dim.label}>
                  <div className="flex items-center justify-between gap-3">
                    <span className="text-sm md:text-base text-foreground-800">{dim.label}</span>
                    <span className="font-heading text-base md:text-lg font-bold text-primary-700">
                      {dim.score.toFixed(1)}
                    </span>
                  </div>
                  <div className="mt-2 h-2 rounded-full bg-background-200 overflow-hidden">
                    <div
                      className="h-full rounded-full bg-primary-500 origin-left animate-growWidth"
                      style={{ width: `${(dim.score / 10) * 100}%`, animationDelay: `${index * 70}ms` }}
                    />
                  </div>
                  <p className="mt-1.5 text-xs text-foreground-500">{dim.note}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}